import { loadFancybox } from './fancyboxLoader'

export default () => {
    let isBound = false

    const selectors = '[data-fancybox], [data-fancybox-unit-search-floorplan]'

    const bindFancybox = ({ Fancybox, de_DE }) => {
        if (isBound) {
            return
        }

        Fancybox.bind('[data-fancybox]', {
            l10n: de_DE,
        })

        Fancybox.bind('[data-fancybox-unit-search-floorplan]', {
            l10n: de_DE,
            on: {
                close: () => {
                    window.dispatchEvent(new CustomEvent('closed-unit-search-floorplan-gallery'))
                },
            },
        })

        isBound = true
    }

    const preload = (event) => {
        if (event.target instanceof Element && event.target.closest(selectors)) {
            loadFancybox()
        }
    }

    const open = async (event) => {
        if (event.defaultPrevented) {
            return
        }

        const trigger = event.target instanceof Element
            ? event.target.closest(selectors)
            : null

        if (! trigger) {
            return
        }

        event.preventDefault()

        const fancybox = await loadFancybox()

        bindFancybox(fancybox)

        fancybox.Fancybox.fromTriggerEl(trigger)
    }

    document.addEventListener('pointerover', preload, { passive: true })
    document.addEventListener('focusin', preload)
    document.addEventListener('click', open)
}
